

// Define type for HistoryItem
import {ItemVM, TemplateOptionVM} from "@cmodules/checklist/assets/data/types"
import {AnyItemVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/item"

class TemplateHistoryItemStore {
  description: string;
  template_id: string;
  revision: string;
  title: string;
  items: AnyItemVM[];
  need_merge_request: boolean;
  has_draft_translations: boolean;
  options: TemplateOptionVM;
  // [key: string]: any;

  constructor(templateHistoryItem: Partial<TemplateHistoryItemStore> = {}) {
    // description = '',
    //   template_id: string | null = null,
    //   revision = '',
    //   title = '',
    //   items: ItemVM[] = [],
    //   need_merge_request = false,
    //   has_draft_translations = false,
    //   options: TemplateOptionVM = new TemplateOptionVM()
    this.description = templateHistoryItem?.description ?? ''
    this.template_id = templateHistoryItem?.template_id ?? ''
    this.revision = templateHistoryItem?.revision ?? ''
    this.title = templateHistoryItem?.title ?? ''
    this.items = templateHistoryItem?.items ?? []
    this.need_merge_request = templateHistoryItem?.need_merge_request ?? false
    this.has_draft_translations = templateHistoryItem?.has_draft_translations ?? false
    this.options = templateHistoryItem?.options ?? new TemplateOptionVM()
  }
}
export {TemplateHistoryItemStore}
